import { render, staticRenderFns } from "./EpiProperty.vue?vue&type=template&id=6238b838"
import script from "./EpiProperty.vue?vue&type=script&lang=js"
export * from "./EpiProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports